import React from "react";

//import { Button } from "antd";
import {
  Grid,
  Segment,
  Divider,
  Header,
  Icon,
  Form,
  Checkbox,
  Button,
} from "semantic-ui-react";
import "antd/dist/antd.css";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import axios from "axios";
import Select from "react-select";

import { reactLocalStorage } from "reactjs-localstorage";
import "react-notifications-component/dist/theme.css";
import "semantic-ui-css/semantic.min.css";
import "@brainhubeu/react-carousel/lib/style.css";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import DateTime from "react-datetime";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";

import { selectedlanguage } from "../actions";
import { API_BASE_URL } from "../utils/endpoints";

var selectedOption = [];

class Settings extends React.Component {
  constructor() {
    super();

    this.state = {
      activeDate_status_value: false,
      activeSenderid_status_value: false,
      startDate: "",
      endDate: "",
      datecheck: false,
      sendercheck: false,
      senders: [],
      countryOptions:[]
    };
  }

  componentDidMount() {
    reactLocalStorage.get("authenticated");
    reactLocalStorage.get("accessToken");
    this.setState({ modalIsOpen: true });
    var lang = i18n.language;
    if (lang === "ar") {
      document.querySelector(".main_div_loading").style = "direction:rtl";
      //      document.querySelector(".menu_header").style = "margin-right:14%";
      document.querySelector(".ant-menu").style = "text-align:right";
      document.querySelector(".blue_color").style =
        "direction: rtl;float: right;";
      document.querySelector(".fixed_profile").style =
        "margin-right: 0% !important;";
    }

    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/loadbytokken";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    }

    var headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorResutl) {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: res.data.result.ErrorResutl,
          animation: "bounce",
          time: 5000,
        });
        window.location = "/app";
      }
    });
    reactLocalStorage.get("user_id_login");
    var lang = i18n.language;
    if (lang === "ar") {
      document.querySelector(".blue_color").style =
        "text-align:right;width: 20%;white-space: pre;";
      //document.querySelector(".profile_add_card").style = "text-align:right";
    }

    ///////////////////////////////////////////// get sender ids////////////////////////////

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.sender_ids != undefined) {
        const senderidoption = res.data.result.sender_ids;
        var length = res.data.result.sender_ids.length;
        var i;
        const newArr = [];
        for (i = 0; i < length; i++) {
          var value_options = senderidoption[i].sender_id;

          newArr.push({
            label: value_options,
            value: senderidoption[i].sender_id,
          });
        }
        this.setState({ options_sender: res.data.result.sender_ids });

       this.setState({countryOptions : newArr}) 
      }
    });

    //////////////////////////////////////////////////////////////////////////////////////////

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/getBlockJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/getBlockJobs";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
     if(res.data.result.block_time!=undefined){
      if (res.data.result.block_time.array_of_sender_id != undefined) {
        const senderidoption = res.data.result.block_time.array_of_sender_id;
        const from = res.data.result.block_time.from;
        const to = res.data.result.block_time.to;

        this.setState({
          activeDate_status_value: res.data.result.block_time.active_date,
        });

        this.setState({
          activeSenderid_status_value:
            res.data.result.block_time.active_sender_id,
        });

        var length = res.data.result.block_time.array_of_sender_id.length;
        var i;

        const newArr = [];
        var object = {};

        for (i = 0; i < length; i++) {
          object = { label: senderidoption[i], value: senderidoption[i] };
          newArr.push(object);
        }
        this.setState({ startDate: from, endDate: to });

        console.log(newArr);
        this.setState({ selectedOption: newArr });
        console.log(this.state.selectedOption);
        this.setState({ senders: this.state.selectedOption });
      }
     }
    });

    /////////////////////////////////////////////////////////////////////////////////////
  }

  onChangeStartDate = (date) => {
    date = new Date(date);
    this.setState({ startDate: date });
  };

  onChangeEndDate = (date) => {
    date = new Date(date);
    this.setState({ endDate: date });
  };

  handleChangeMenu = (selectedOption) => {
    this.setState({ selectedOption, senders: selectedOption });
  };

  activeDate() {
    //this.setState({activeDate_status_value: !this.state.activeDate_status_value});

    //reactLocalStorage.set("active_date" ,this.state.activeDate_status_value)
    if (this.state.activeDate_status_value === false) {
      this.setState({ account_status_value: true });
      document.getElementById("data_check").checked = true;
    } else if (this.activeDate_status_value === true) {
      this.setState({ activeDate_status_value: false });
      document.getElementById("data_check").checked = false;
    }
  }

  activeSenderid() {
    //this.setState({activeSenderid_status_value: !this.state.activeSenderid_status_value});
    // reactLocalStorage.set("active_sender_id" ,this.state.activeSenderid_status_value)
    if (this.state.activeSenderid_status_value === false) {
      this.setState({ activeSenderid_status_value: true });
      document.getElementById("sender_check").checked = true;
    } else if (this.activeSenderid_status_value === true) {
      this.setState({ activeSenderid_status_value: false });
      document.getElementById("sender_check").checked = false;
    }
  }

  handleSubmit = (event) => {
    var token = reactLocalStorage.get("accessToken");

    event.preventDefault();

    var array_send_sender = [];
    var i;
    for (i = 0; i < this.state.senders.length; i++) {
      array_send_sender.push(this.state.senders[i].value);
    }

    /* if(reactLocalStorage.get("active_date")==="true")
    {
     
  
     this.setState({activeDate_status_value:true})
    }

   if(reactLocalStorage.get("active_date")==="false") {
      this.setState({activeDate_status_value:false})
    }

    if(reactLocalStorage.get("active_sender_id")==="true")
    {
      
      this.setState({activeSenderid_status_value:true})
    }
    if(reactLocalStorage.get("active_sender_id")==="false"){
      this.setState({activeSenderid_status_value:false})

    } */

    const data = {
      from: this.state.startDate,
      to: this.state.endDate,
      active_date: this.state.activeDate_status_value,
      active_sender_id: this.state.activeSenderid_status_value,
      array_of_sender_id: array_send_sender,
    };

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/blockJobs";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/blockJobs";
    }

    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            window.location = "Setting";
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        } else {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  render() {
    const { selectedOption } = this.state;

    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_request">
            <div className="main_request">
              <Grid columns={2} divided className="fixed_profile">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo ">
                    <Segment>
                      <h3 className="text_style blue_color">
                        {reactLocalStorage.get("lang") === "ar" ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "100px" }}
              >
                <br />
                <Divider horizontal>
                  {" "}
                  <Header as="h2">
                    <Icon name="settings " />
                    Settings
                  </Header>
                </Divider>

                <br />
                <Form>
                  <div className="row">
                    <div className="col-lg-6">
                      {i18n.t("start_date.label")}

                      <DateTime
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                        className="test"
                        closeOnSelect={true}
                        closeOnTab={true}
                        locale={i18n.language}
                      />
                      <br />
                    </div>
                    <div className="col-lg-6">
                      {i18n.t("end_date.label")}
                      <DateTime
                        onChange={this.onChangeEndDate}
                        value={this.state.endDate}
                        className="test"
                        closeOnSelect={true}
                        closeOnTab={true}
                        locale={i18n.language}
                      />
                      <br />
                    </div>

                    <div className="col-lg-12">
                      <br />
                      <div className="row">
                        <div className="col-lg-6">
                          {i18n.t("active_date.label")}
                          <select
                            className="myselect"
                            value={this.state.activeDate_status_value}
                            onChange={(activeDate_status_value) => {
                              this.setState({
                                activeDate_status_value:
                                  activeDate_status_value.target.value,
                              });
                            }}
                          >
                            <option selected hidden>
                              Choose Value
                            </option>
                            <option selected value="true">
                              True
                            </option>
                            <option selected value="false">
                              False
                            </option>
                          </select>
                        </div>

                        <div className="col-lg-6">
                          {i18n.t("active_sender.label")}
                          <select
                            className="myselect"
                            value={this.state.activeSenderid_status_value}
                            onChange={(activeSenderid_status_value) => {
                              this.setState({
                                activeSenderid_status_value:
                                  activeSenderid_status_value.target.value,
                              });
                            }}
                          >
                            <option selected hidden>
                              Choosw Value
                            </option>
                            <option selected value="true">
                              True
                            </option>
                            <option selected value="false">
                              False
                            </option>
                          </select>
                        </div>
                      </div>
                      <br />

                      {i18n.t("Sender_ID.label")}

                      <Select
                        isMulti
                        placeholder="Select ..."
                        search
                        selection
                        value={selectedOption}
                        onChange={this.handleChangeMenu}
                        options={this.state.countryOptions}
                        id="sender_select"
                      />
                    </div>

                    <br />
                  </div>

                  <br />
                </Form>

                <Form style={{ textAlign: "center" }}>
                  {" "}
                  <Button
                    content={i18n.t("Submit.label")}
                    basic
                    color="black"
                    onClick={this.handleSubmit}
                  />
                </Form>
              </Segment>
            </div>
          </div>

          <SemanticToastContainer />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(
  mapStateToProps,
  { selectedlanguage }
)(Settings);
